// standaloneActService.js - acte adiționale fără contract în aplicație (contracte legacy)

import api from './api';

const API_ROUTE = '/standalone-acts';

export const standaloneActService = {
  async getAll() {
    const response = await api.get(API_ROUTE);
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`${API_ROUTE}/${id}`);
    return response.data;
  },

  // Câmpurile formularului (variabilele template-ului), precompletate
  async getForm(actType, clientId) {
    const response = await api.get(`${API_ROUTE}/form`, {
      params: { actType, ...(clientId ? { clientId } : {}) },
    });
    return response.data;
  },

  async create(data) {
    const response = await api.post(API_ROUTE, data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.put(`${API_ROUTE}/${id}`, data);
    return response.data;
  },

  async delete(id) {
    await api.delete(`${API_ROUTE}/${id}`);
  },

  async generatePdf(id) {
    const response = await api.post(`${API_ROUTE}/${id}/generate-pdf`);
    return response.data;
  },

  async downloadPdf(id) {
    const response = await api.get(`${API_ROUTE}/${id}/download-pdf`, {
      responseType: 'blob',
    });

    const contentDisposition = response.headers['content-disposition'];
    let filename = `act_aditional_${id}.pdf`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^"';]+)['"]?(?:$|;)/i);
      if (filenameMatch && filenameMatch[1]) {
        filename = decodeURIComponent(filenameMatch[1].replace(/^UTF-8''/i, '').replace(/['"]/g, ''));
      }
    }

    return { blob: response.data, filename };
  },

  async send(id, { emails, subject, message }) {
    const response = await api.post(`${API_ROUTE}/${id}/send`, { emails, subject, message });
    return response.data;
  },
};
